import { createTypes, createAction } from "lib/action";

const LOAD_COMPANY = createTypes("company", "load");
const SHOW_COMPANY = createTypes("company", "show");
const CREATE_COMPANY = createTypes("company", "create");
const UPDATE_COMPANY = createTypes("company", "update");
const DELETE_COMPANY = createTypes("company", "delete");
const IMPORT_COMPANY = createTypes("company", "import");
const EXPORT_COMPANY = createTypes("company", "export");

const loadCompanies = {
  request: (params, token) => createAction(LOAD_COMPANY.REQUEST, { params, token }),
  success: data => createAction(LOAD_COMPANY.SUCCESS, { data }),
  failure: err => createAction(LOAD_COMPANY.FAILURE, { err }),
};

const showCompany = {
  request: (id, token) => createAction(SHOW_COMPANY.REQUEST, { id, token }),
  success: data => createAction(SHOW_COMPANY.SUCCESS, { data }),
  failure: err => createAction(SHOW_COMPANY.FAILURE, { err }),
};

const createCompany = {
  request: (params, token) => createAction(CREATE_COMPANY.REQUEST, { params, token }),
  success: data => createAction(CREATE_COMPANY.SUCCESS, { data }),
  failure: err => createAction(CREATE_COMPANY.FAILURE, { err }),
};

const updateCompany = {
  request: (params, id, token) => createAction(UPDATE_COMPANY.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_COMPANY.SUCCESS, { data }),
  failure: err => createAction(UPDATE_COMPANY.FAILURE, { err }),
};

const deleteCompany = {
  request: (id, token) => createAction(DELETE_COMPANY.REQUEST, { id, token }),
  success: id => createAction(DELETE_COMPANY.SUCCESS,  { id } ),
  failure: err => createAction(DELETE_COMPANY.FAILURE, { err }),
};

const importCompany = {
    request: (file, company_id, token) => createAction(IMPORT_COMPANY.REQUEST, { file, company_id, token }),
    success: data => createAction(IMPORT_COMPANY.SUCCESS, { data }),
    failure: err => createAction(IMPORT_COMPANY.FAILURE, { err }),
}

const exportCompany = {
    request: (token, company_id) => createAction(EXPORT_COMPANY.REQUEST, { token, company_id }),
    success: data => createAction(EXPORT_COMPANY.SUCCESS, { data }),
    failure: err => createAction(EXPORT_COMPANY.FAILURE, { err }),
}

export {
  loadCompanies,
  showCompany,
  createCompany,
  updateCompany,
  deleteCompany,
  importCompany,
  exportCompany,
  LOAD_COMPANY,
  SHOW_COMPANY,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  IMPORT_COMPANY,
  EXPORT_COMPANY
};
